import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ACCACCOUNTCLOSE,
  DELETE_ACCACCOUNTCLOSE,
  UPDATE_ACCACCOUNTCLOSE,
  ADD_NEW_ACCACCOUNTCLOSE,
} from "./actionType";

import {
  getAccAccountCloseSuccess,
  getAccAccountCloseFail,
  deleteAccAccountCloseSuccess,
  deleteAccAccountCloseFail,
  updateAccAccountCloseSuccess,
  updateAccAccountCloseFail,
  addAccAccountCloseSuccess,
  addAccAccountCloseFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAccAccountCloseApi,
  getAccAccountCloseApi,
  updateAccAccountCloseApi,
  deleteAccAccountCloseApi,
  addNewAccAccountCloseApi
} from "../../helpers/backend_helper";

function* getAccAccountClose({ payload: accAccountClose }) {
  try {
    const response = yield call(getAccAccountCloseApi, accAccountClose);
    yield put(getAccAccountCloseSuccess(GET_ACCACCOUNTCLOSE, response.data));
  } catch (error) {
    yield put(getAccAccountCloseFail(GET_ACCACCOUNTCLOSE, error));
  }
}

function* onUpdateAccAccountClose({ payload: accAccountClose }) {
  try {
    if (accAccountClose.setApprove) {
      const response = yield call(approveAccAccountCloseApi, accAccountClose);
      yield put(updateAccAccountCloseSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAccAccountCloseApi, accAccountClose);
      yield put(updateAccAccountCloseSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAccAccountCloseFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAccAccountClose({ payload: accAccountClose }) {
  try {
    const response = yield call(deleteAccAccountCloseApi, accAccountClose);
    yield put(deleteAccAccountCloseSuccess({ accAccountClose, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAccAccountCloseFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAccAccountClose({ payload: accAccountClose }) {
  try {
    const response = yield call(addNewAccAccountCloseApi, accAccountClose);
    yield put(addAccAccountCloseSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAccAccountCloseFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAccAccountClose() {
  yield takeEvery(GET_ACCACCOUNTCLOSE, getAccAccountClose);
}

export function* watchUpdateAccAccountClose() {
  yield takeEvery(UPDATE_ACCACCOUNTCLOSE, onUpdateAccAccountClose);
}

export function* watchDeleteAccAccountClose() {
  yield takeEvery(DELETE_ACCACCOUNTCLOSE, onDeleteAccAccountClose);
}

export function* watchAddNewAccAccountClose() {
  yield takeEvery(ADD_NEW_ACCACCOUNTCLOSE, onAddNewAccAccountClose);
}

function* accAccountCloseSaga() {
  yield all([
    fork(watchGetAccAccountClose),
    fork(watchDeleteAccAccountClose),
    fork(watchUpdateAccAccountClose),
    fork(watchAddNewAccAccountClose)
  ]);
}

export default accAccountCloseSaga;
